/**
 * Default cost configuration values for Pulse 360.
 */
export const DEFAULT_COST_CONFIG = {
  phone_call_cost: 7.50,
  agent_chat_cost: 1.50,
  automated_conversation_cost: 0.00,
};
